export const calculateMapCenter = (providers) => {
    if (providers.length === 0) return [0, 0];
    
    const latSum = providers.reduce((sum, provider) => sum + provider.latitude, 0);
    const lngSum = providers.reduce((sum, provider) => sum + provider.longitude, 0);
    
    return [latSum / providers.length, lngSum / providers.length];
  };